import { AxiosResponse } from "axios";
import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import {
  setPushMessages,
  setPushMessageErrorMessage,
  setPushMessageActionStart,
} from "../../constants/reducers/push-message.reducer";
import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { GetAllPushMessageDTO } from "../../constants/dto/push-message";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";

let body: GetAllPushMessageDTO;

export const getAllPushMessage = async (
  givenIsSent: boolean | undefined = undefined,
) => {
  store.dispatch(setPushMessageActionStart(true));
  let { searchText, page, isSent } = store.getState().pushMessage;
  const queryParams = new URLSearchParams();

  if (givenIsSent !== undefined) isSent = givenIsSent;

  if (searchText) queryParams.append("searchText", searchText);
  queryParams.append("page", page ? page.toString() : "1");
  if (isSent !== undefined) queryParams.append("isSent", isSent.toString());

  const request = await createCall(
    "cms/push-messages",
    BASE_METHODS.GET,
    "application/json",
    "1.0.0",
    undefined,
    queryParams,
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(GetAllPushMessageDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setPushMessageErrorMessage(
          TextEnum.GET_ALL_PUSH_MESSAGE_INVALID_RESPONSE,
        ),
      );
      return null;
    }
    store.dispatch(
      setPushMessages({
        pushMessages: response.data.pushMessages,
        pageCount: response.data.pageCount,
      }),
    );
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponeData: CustomErrorType = responseError.response?.data;
    if (errorResponeData) {
      let errorMessage = "";
      switch (errorResponeData.code) {
        case 8001:
          errorMessage = TextEnum.GET_ALL_PUSH_MESSAGE_ERROR_IN_SENT_RESPONSE;
          break;

        default:
          break;
      }
      store.dispatch(setPushMessageErrorMessage(errorMessage));
      return null;
    }
    store.dispatch(setPushMessageActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
